import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Login from "./component";
import { loginUserAndAuthenticate } from "../login/actions";
import { searchUser, sendRefundRequest } from "./actions";

import AdminSearch from "./component";
import {
  accountCancellation,
  getBilling,
  getTransactionDetail,
} from "../settings/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      searchUserConnect: searchUser,
      AccountCancellationConnect: accountCancellation,
      GetTransactionDetailConnect: getTransactionDetail,
      GetBillingConnect: getBilling,
      sendRefundRequestConnect: sendRefundRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminSearch);
